export default __webpack_public_path__ + "static/media/9.c14597ad.png";